import { useAuthStore } from "src/stores/auth-store";
import { notUndefined } from "src/utils";

import { type Me, useGetMeQueryData } from "./useGetMe";

// todo: remove getMyLoginFromLegacyAuthProvider once Okta is fully activated
function getMyLoginFromLegacyAuthProvider(getMeQueryData: { me: Me } | undefined): string {
  return notUndefined(getMeQueryData).me.login;
}

export const useMyLogin = (): string | null => {
  const { loginFromNewAuthProvider, isOktaLoginEnabled } = useAuthStore();
  const { data: getMeQueryData } = useGetMeQueryData();

  return isOktaLoginEnabled
    ? loginFromNewAuthProvider
    : getMyLoginFromLegacyAuthProvider(getMeQueryData);
};
